import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { deleteFileFromDropbox } from '../slices/DropboxSlice';
import { useAppDispatch, useAppSelector } from '../slices/store';
import { bytesToSize } from '../utils/FileUtils';
import { BorrowerDto } from '../openapi/atlantis';
import DefaultLoader from './DefaultLoader';

interface FileRowProps {
  file: any;
  checklistItemId?: string;
}

const FileRow: React.FC<FileRowProps> = ({ file, checklistItemId }) => {
  const dispatch = useAppDispatch();
  const { applicationId } = useParams();
  const {
    auth: { authUserDetail },
    loan: { borrowerDetail },
  } = useAppSelector((state) => state);
  const [isDeletingFile, setIsDeletingFile] = useState<boolean>();
  const borrowerData = applicationId
    ? ({
        id: authUserDetail?.id,
        dropboxId: authUserDetail?.dropboxId,
      } as BorrowerDto)
    : borrowerDetail!;

  return (
    <div
      key={file.id}
      className='flex flex-row items-center justify-between pb-4'
    >
      <p className='font-inter-medium text-xs text-black w-11/12'>
        {file.filename}{' '}
        <p className='text-primary-gray'>({bytesToSize(file.length!)})</p>
      </p>
      <button
        onClick={async () => {
          setIsDeletingFile(true);
          await dispatch(
            deleteFileFromDropbox(
              borrowerData,
              file?.id!,
              applicationId ? true : false,
              checklistItemId,
            ),
          );
          setIsDeletingFile(false);
        }}
        disabled={!!isDeletingFile}
      >
        {isDeletingFile ? (
          <DefaultLoader iconSize={10} noPadding />
        ) : (
          <FontAwesomeIcon
            icon={faTrash}
            fontSize={12}
            data-testid='delete-file-icon'
            className='text-primary-gray'
          />
        )}
      </button>
    </div>
  );
};

export default FileRow;
